import { render, staticRenderFns } from "./wrestler_weight_list.vue?vue&type=template&id=7069888a&"
import script from "./wrestler_weight_list.vue?vue&type=script&lang=js&"
export * from "./wrestler_weight_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports